import './App.css';
import BodyMain from './Body/BodyMain';
import Title from './Title/Title';


//frames
const width = 1000
const height = 760
const gutter = 3
const innerHeight = height - gutter*2
const innerWidth = width - gutter*2
const titleSectionHeight = innerHeight * 0.12
const bodySectionHeight = innerHeight - titleSectionHeight

const focusCountry = "myanmar"

function App() {
  return (
    <div className="App" style={{width:width, height:height, background: "#12425e",display:"flex",justifyContent:"center",alignItems:"center"}}>
      <div id="AppInner" style={{height:innerHeight,width:innerWidth,background:"black"}}>
      <Title
      focusCountry={focusCountry}
      height={titleSectionHeight}
      width={innerWidth}
      />
      <BodyMain 
       height={bodySectionHeight}
       width={innerWidth}
       focusCountry={focusCountry}
      />
      </div>
    </div>
  );
}

export default App;
